import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [subscription, setSubscription] = useState(null);

  const loadSubscription = useCallback(async () => {
    try {
      const { data } = await api.get("/subscription");
      setSubscription(data);
      return data;
    } catch {
      setSubscription(null);
      return null;
    }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("clipstar_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadSubscription();
    } catch {
      localStorage.removeItem("clipstar_token");
      setUser(false);
    }
  }, [loadSubscription]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (token, userObj) => {
    localStorage.setItem("clipstar_token", token);
    setUser(userObj);
    await loadSubscription();
  };

  const logout = () => {
    localStorage.removeItem("clipstar_token");
    setUser(false);
    setSubscription(null);
  };

  const isPaid = subscription?.is_active_paid || user?.role === "admin";

  return (
    <AuthContext.Provider
      value={{ user, subscription, isPaid, login, logout, loadSubscription, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
